/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ServiceBillingMode } from './serviceBillingMode';


export interface RevenueShareDetails { 
    deliveryPartner?: string;
    revenueShareDeliveryPartner: number;
    serviceProviderRevenueShare: number;
    telco?: string;
    revenueShareTelco: number;
    contentPartner?: string;
    revenueShareContentPartner: number;
    serviceBillingMode: ServiceBillingMode;
}
